import { useLocation, useNavigate } from "react-router-dom";

// Wrapper para la función navigate() de react-router-dom, compatible con la funcionalidad
// del middleware RedirectWhenNotNavigated

// Este navigate siempre tendrá un location.state vacío por defecto. Esto permitirá que la función middleware
// pueda realizar sus verificaciones de manera normal
const useCompatNavigate = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const compatNavigate = (to, options = {}) => {
    navigate(to, {
      ...options,
      state: {
        ...(options.state ?? {}),
        ...(location.state?.fromPreviousRedirect ? { fromPreviousRedirect: true } : {}),
        previousPath: location.pathname,
      },
    });
  };

  return compatNavigate;
};

export default useCompatNavigate;
